<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Section"
  model-name="challenge"
  param="challengeId"
  page-prefix="/blade/challenges"
  :create="createChallenge"
  :fetch="getChallenge"
  :fetch-types="getChallengeTypes"
  :update="updateChallenge"
  :remove="deleteChallenge"
  :enum-names="['characters', 'variants', 'metrics', 'roles', 'environments', 'eventPools', 'teamDecisions', 'narrativeTypes', 'speakers']"
  :stub="challenge"
  :validator="validator"
  :utils="utils">
<template slot-scope="{ model: challenge, enums: { characters, variants, metrics, roles, environments, eventPools, teamDecisions, narrativeTypes, speakers }, utils: { unused }, validator }">
  <text-input label v-model.trim="challenge.name" :validator="validator.name" required autofocus>Name</text-input>

  <text-input label v-model.trim="challenge.title" :validator="validator.title" required>Title</text-input>

  <text-input label v-model.trim="challenge.description" textarea>Description</text-input>

  <select-input label v-model="challenge.environment" :options="environments" use="_id" :display="e => { return `${e.name}`; }" :to="(id) => { return `/blade/environments/${id}/edit`; }">Gamulation Branding for this Section</select-input>

  <checkbox-input v-model="challenge.skipRoleDisplay">
    Skip Role Display
  </checkbox-input>

  <select-input
    v-model="challenge.startingTeamDecision"
    :validator="validator.startingTeamDecision"
    label
    :options="teamDecisions"
    use="_id"
    display="name"
    :to="(id) => { return `/blade/major-decisions/${id}/edit`; }"
  >Starting Major Decision (overrides Event Pool)</select-input>

  <select-input
    v-model="challenge.eventPool"
    :validator="validator.eventPool"
    label
    :options="eventPools"
    use="_id"
    display="name"
    autofocus
    :to="(id) => { return `/blade/event-pools/${id}/edit`; }"
  >
    Event Pool (overridden by Starting Major Decision)
  </select-input>

  <number-input label v-model="challenge.preCashAdjustment">Pre Cash Adjustment</number-input>

  <array-input :items="challenge.preMetricAdjustments" :disabled="validator.preMetricAdjustments.$invalid" :hide-button="challenge.preMetricAdjustments.length >= metrics.filter(m => m.type === 'team').length">
    <h5 slot="title">Pre Metric Adjustments</h5>

    <div class="form-row" slot="item" slot-scope="{ item: metricAdjustment, index: i }">
      <select-input class="col-sm-8" v-model="metricAdjustment.metric" :validator="validator.preMetricAdjustments.$each[i].metric" :options="unused(metrics.filter(m => m.type === 'team')).by('_id').in(challenge.preMetricAdjustments).by('metric').at(i)" use="_id" :display="m => { return `${m.name} (${m.type})`; }" required autofocus :to="(id) => { return `/blade/metrics/${id}/edit`; }">Metric</select-input>

      <number-input class="col-sm-4" v-model="metricAdjustment.adjustment" :validator="validator.preMetricAdjustments.$each[i].adjustment" required non-zero :remove="() => { challenge.preMetricAdjustments.splice(i, 1); }">Adjustment</number-input>
    </div>
    <span slot="button">Add Pre Metric Adjustment</span>
  </array-input>

  <number-input label v-model="challenge.postCashAdjustment">Post Cash Adjustment</number-input>

  <array-input :items="challenge.postMetricAdjustments" :disabled="validator.postMetricAdjustments.$invalid" :hide-button="challenge.postMetricAdjustments.length >= metrics.filter(m => m.type === 'team').length">
    <h5 slot="title">Post Metric Adjustments</h5>

    <div class="form-row" slot="item" slot-scope="{ item: metricAdjustment, index: i }">
      <select-input class="col-sm-8" v-model="metricAdjustment.metric" :validator="validator.postMetricAdjustments.$each[i].metric" :options="unused(metrics.filter(m => m.type === 'team')).by('_id').in(challenge.postMetricAdjustments).by('metric').at(i)" use="_id" :display="m => { return `${m.name} (${m.type})`; }" required autofocus :to="(id) => { return `/blade/metrics/${id}/edit`; }">Metric</select-input>

      <number-input class="col-sm-4" v-model="metricAdjustment.adjustment" :validator="validator.postMetricAdjustments.$each[i].adjustment" required non-zero :remove="() => { challenge.postMetricAdjustments.splice(i, 1); }">Adjustment</number-input>
    </div>
    <span slot="button">Add Post Metric Adjustment</span>
  </array-input>

  <narrative-input :narratives="challenge.introNarratives" :validator="validator.introNarratives" :characters="characters" :variants="variants" :narrative-types="narrativeTypes" :speakers="speakers">Section Intro Narrative</narrative-input>

  <narrative-input :narratives="challenge.outroNarratives" :validator="validator.outroNarratives" :characters="characters" :variants="variants" :narrative-types="narrativeTypes" :speakers="speakers">Section Outro Narrative</narrative-input>

  <array-input :items="challenge.switchRoles" :disabled="validator.switchRoles.$invalid">
    <h5 slot="title">Role Switches</h5>

    <div class="form-row" slot="item" slot-scope="{ item: switchRole, index: i }">
      <select-input class="col-sm-4" v-model="switchRole.fromRole" :validator="validator.switchRoles.$each[i].fromRole" :options="unused(roles.filter(r => r)).by('_id').in(challenge.switchRoles).by('fromRole').at(i)" use="_id" :display="r => { return r.name; }" required autofocus :to="(id) => { return `/blade/roles/${id}/edit`; }">From Role</select-input>

      <select-input class="col-sm-5" v-model="switchRole.toRole" :validator="validator.switchRoles.$each[i].toRole" :options="unused(roles.filter(r => r)).by('_id').in(challenge.switchRoles).by('toRole').at(i)" use="_id" :display="r => { return r.name; }" required autofocus :to="(id) => { return `/blade/roles/${id}/edit`; }" :remove="() => { challenge.switchRoles.splice(i, 1); }">To Role</select-input>

      <checkbox-input class="col-sm-3" v-model="switchRole.carryOverPlayerBackground">
        Carry Over Player Background
      </checkbox-input>
    </div>
    <span slot="button">Add Role Switch</span>
  </array-input>

  <h4>Completion Email Notifications</h4>
  <checkbox-input v-model="challenge.enableCompletionEmailNotifications">
    Enable Completion Email Notifications
  </checkbox-input>
  <template v-if="challenge.enableCompletionEmailNotifications">
    <!--
    completionEmailNotificationsDelayDays: { type: Number, default: 0 },
    completionEmailNotificationsSubject: { type: String, trim: true, default: '' },
    completionEmailNotificationsBody: { type: String, trim: true, default: '' },
    completionEmailNotificationsCC: { type: String, trim: true, default: '' },
     -->
     <number-input label v-model="challenge.completionEmailNotificationsDelayDays">Delay (Days - decimal values are supported)</number-input>
     <text-input label v-model.trim="challenge.completionEmailNotificationsSubject">Subject</text-input>
     <text-input label v-model.trim="challenge.completionEmailNotificationsBody" textarea>Body</text-input>
     <text-input label v-model.trim="challenge.completionEmailNotificationsCC">CC</text-input>
  </template>
</template>
</edit-page>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import { nonZero, narrative } from '../../../utils/validators';
import { unused } from '../../../utils/utils';

import EditPage from '../../ui/pages/EditPage';
import NarrativeInput from '../../ui/inputs/NarrativeInput';

import ArrayInput from '../../ui/inputs/ArrayInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';
import NumberInput from '../../ui/inputs/NumberInput';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';

export default {
  components: {
    EditPage,
    NarrativeInput,
    ArrayInput,
    NumberInput,
    SelectInput,
    TextInput,
    CheckboxInput
  },
  data() {
    return {
      utils: {
        unused
      },
      challenge: {
        _id: '',
        name: '',
        title: '',
        description: '',
        skipRoleDisplay: false,
        environment: '',
        completionEmailNotificationsDelayDays: 0,
        completionEmailNotificationsSubject: '',
        completionEmailNotificationsBody: '',
        completionEmailNotificationsCC: '',
        enableCompletionEmailNotifications: false,
        startingTeamDecision: '',
        preCashAdjustment: 0,
        preMetricAdjustments: [],
        postCashAdjustment: 0,
        postMetricAdjustments: [],
        introNarratives: [],
        outroNarratives: [],
        switchRoles: []
      },
      validator: {
        name: { required },
        title: { required },
        startingTeamDecision: { required: requiredIf(({ eventPool }) => !eventPool) },
        eventPool: { required: requiredIf(({ startingTeamDecision }) => !startingTeamDecision) },
        preMetricAdjustments: {
          $each: {
            metric: { required },
            adjustment: { required, nonZero }
          }
        },
        postMetricAdjustments: {
          $each: {
            metric: { required },
            adjustment: { required, nonZero }
          }
        },
        introNarratives: narrative(),
        outroNarratives: narrative(),
        switchRoles: {
          $each: {
            fromRole: { required },
            toRole: { required }
          }
        }
      }
    };
  },
  methods: {
    ...mapActions([
      'getChallenge',
      'getChallengeTypes',
      'createChallenge',
      'updateChallenge',
      'deleteChallenge'
    ])
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ChallengeEdit.vue